export enum UserListItemAction {
  Activate,
  Edit,
  More,
  Preview,
  Remove,
  ResendActivationMessage,
}
